import { MapPinIcon } from "@phosphor-icons/react";
import { useIntl } from "react-intl";

import { Button } from "@/components/Button/Button";
import type { HotelData } from "@/features/hotels/types/types";

interface HotelLocationCardProps {
  hotel: HotelData;
}

export const HotelLocationCard = ({ hotel }: HotelLocationCardProps) => {
  const intl = useIntl();

  if (!hotel.geolocation && !hotel.address) return null;

  const { latitude, longitude } = hotel.geolocation ?? {};
  const googleMapsUrl =
    latitude != null && longitude != null
      ? `https://www.google.com/maps?q=${latitude},${longitude}`
      : `https://www.google.com/maps/search/${encodeURIComponent([hotel.name, hotel.address].filter(Boolean).join(", "))}`;

  return (
    <div className="section-card flex flex-col gap-5">
      <div className="flex flex-col gap-3">
        <p className="w-full text-lg font-semibold text-text-primary">
          {intl.formatMessage({
            defaultMessage: "Location",
            description: "Hotel's location card title",
          })}
        </p>
        {hotel.address && (
          <div className="flex items-center gap-1">
            <MapPinIcon size={16} className="shrink-0 text-text-primary" />
            <p className="text-sm text-text-primary">{hotel.address}</p>
          </div>
        )}
      </div>
      <Button
        as="a"
        href={googleMapsUrl}
        target="_blank"
        rel="noopener noreferrer"
        fullWidth
        variant="outlined"
      >
        {intl.formatMessage({
          defaultMessage: "View on Map",
          description: "Button to open hotel location in Google Maps",
        })}
      </Button>
    </div>
  );
};
